// 订单状态枚举
export const ORDER_STATUS = {
  PENDING_PAYMENT: 0, // 待支付
  CANCELLED: 1, // 已取消
  PENDING_TICKET: 2, // 待出票
  TICKETING: 3, // 出票中
  TICKETED: 4, // 已出票
  TICKET_FAILED: 5, // 出票失败
  REFUNDING: 6, // 退票中
  REFUNDED: 7, // 已退票
  CHANGING: 8, // 改签中
  CHANGE_SUCCESS: 9, // 改签成功
  PAY_SUCCESS_PENDING_TICKET: 10, // 支付成功等待出票
  AUTO_TICKET_FAILED: 11 // 自动出票失败
}

// 订单状态文本映射
export const ORDER_STATUS_TEXT = {
  [ORDER_STATUS.PENDING_PAYMENT]: '待支付',
  [ORDER_STATUS.CANCELLED]: '已取消',
  [ORDER_STATUS.PENDING_TICKET]: '待出票',
  [ORDER_STATUS.TICKETING]: '出票中',
  [ORDER_STATUS.TICKETED]: '已出票',
  [ORDER_STATUS.TICKET_FAILED]: '出票失败',
  [ORDER_STATUS.REFUNDING]: '退票中',
  [ORDER_STATUS.REFUNDED]: '已退票',
  [ORDER_STATUS.CHANGING]: '改签中',
  [ORDER_STATUS.CHANGE_SUCCESS]: '改签成功',
  [ORDER_STATUS.PAY_SUCCESS_PENDING_TICKET]: '支付成功等待出票',
  [ORDER_STATUS.AUTO_TICKET_FAILED]: '自动出票失败'
}

// 会员状态枚举
export const MEMBER_STATUS = {
  NORMAL: 0, // 正常
  DISABLED: 1, // 已禁用
  CANCELLED: 2 // 已注销
}

// 会员状态文本映射
export const MEMBER_STATUS_TEXT = {
  [MEMBER_STATUS.NORMAL]: '正常',
  [MEMBER_STATUS.DISABLED]: '已禁用',
  [MEMBER_STATUS.CANCELLED]: '已注销'
}

// 支付状态枚举
export const PAY_STATUS = {
  PENDING: 0, // 待支付
  PAYING: 1, // 支付中
  SUCCESS: 2, // 成功
  FAILED: 3, // 失败
  TIMEOUT: 4 // 超时
}

// 支付状态文本映射
export const PAY_STATUS_TEXT = {
  [PAY_STATUS.PENDING]: '待支付',
  [PAY_STATUS.PAYING]: '支付中',
  [PAY_STATUS.SUCCESS]: '成功',
  [PAY_STATUS.FAILED]: '失败',
  [PAY_STATUS.TIMEOUT]: '超时'
}

// 业务类型枚举
export const BUSINESS_TYPE = {
  TINGGO_TICKET: '1', // tinggo机票
  KONGTIE_TICKET: '2' // 51kongtie机票
}

// 业务类型文本映射
export const BUSINESS_TYPE_TEXT = {
  [BUSINESS_TYPE.TINGGO_TICKET]: 'tinggo机票',
  [BUSINESS_TYPE.KONGTIE_TICKET]: '51kongtie机票'
}

// 支付平台枚举
export const PAY_PLATFORM = {
  C2C2P: '1', // 2c2p
  AIRWALLEX: '2', // airwallex
  CASH: '3', // cash
  WECHAT: '4', // wechat
  ALIPAY: '5' // alipay
}

// 支付平台文本映射
export const PAY_PLATFORM_TEXT = {
  [PAY_PLATFORM.C2C2P]: '2c2p',
  [PAY_PLATFORM.AIRWALLEX]: 'airwallex',
  [PAY_PLATFORM.CASH]: 'cash',
  [PAY_PLATFORM.WECHAT]: 'wechat',
  [PAY_PLATFORM.ALIPAY]: 'alipay'
}

// 风险等级枚举
export const RISK_LEVEL = {
  LOW: 'low', // 低
  MEDIUM: 'medium', // 中
  HIGH: 'high' // 高
}

// 风险等级文本映射
export const RISK_LEVEL_TEXT = {
  [RISK_LEVEL.LOW]: '低',
  [RISK_LEVEL.MEDIUM]: '中',
  [RISK_LEVEL.HIGH]: '高'
}

// 订单标签页类型
export const ORDER_TAB_TYPE = {
  UNTICKETED: 'unticketed', // 未出票订单
  TICKETED: 'ticketed', // 已出票订单
  PROBLEM: 'problem', // 问题订单
  CANCELLED: 'cancelled', // 取消订单
  ALL: 'all' // 全部订单
}
